import { errCodesMap } from '../error/code';
import {
  UPLOAD_FILE_EXT_RESTRICTIONS,
  UPLOAD_IMAGE,
  UPLOAD_VIDEO,
} from './constant';
import { getFileExt } from './helper';

/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-07-09 15:33:18
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-07-12 21:13:00
 * @FilePath: /unifyxp-v2-store-portal/src/tools/validate.ts
 */
export const validateUploadingFiles = (file) => {
  const error: Array<any> = [];
  const extension = getFileExt(file.name);
  if (
    UPLOAD_FILE_EXT_RESTRICTIONS.indexOf(extension?.toLocaleLowerCase()) === -1
  ) {
    error.push(errCodesMap[999982]);
  }
  if (UPLOAD_IMAGE.indexOf(extension?.toLocaleLowerCase()) !== -1) {
    if (file.size > 20 * 1024 * 1024) {
      error.push(errCodesMap[999983]);
    }
  }
  if (UPLOAD_VIDEO.indexOf(extension?.toLocaleLowerCase()) !== -1) {
    if (file.size > 500 * 1024 * 1024) {
      error.push(errCodesMap[999983]);
    }
  }
  return error;
};
